'use strict';exports.__esModule = true;var checkIsForeignAddress = function checkIsForeignAddress(address) {
  if (!address || !address.en || !address.he) {
    return false;
  }

  return (address.en.country_name || '').toLowerCase() !== 'israel' ||
  (address.he.country_name || '').toLowerCase() !== 'ישראל';
};exports.default =

checkIsForeignAddress;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/checkIsForeignAddress.js
// module id = 97
// module chunks = 0